/* AB Test V_SA_CHECK_06 | One-Tap Refills - Sized to the Journal (Checkout)
 *
 * Loaded by sections/c-v-sa-check-06.liquid (overlay group, every page).
 *
 * Test entry gate: keeps a cookie in sync with the cart. While the cart contains one of the
 * configured Momento products the cookie is set; otherwise it is removed. The Intelligems
 * audience only assigns visitors who have the cookie, so only Momento shoppers join the test.
 *
 * The cart is re-read on page load, on UpCart cart events, on theme cart events, and after
 * any storefront request to /cart/add, /cart/change, /cart/update or /cart/clear.
 * Handles, cookie name and lifetime come from data-* attributes (section settings).
 */
(function () {
  if (window.cVSaCheck06) return;
  window.cVSaCheck06 = true;

  var config = document.getElementById('c-v-sa-check-06-config');
  if (!config) return;

  var handles = (config.getAttribute('data-handles') || '')
    .split(',')
    .map(function (h) { return h.trim(); })
    .filter(Boolean);
  var cookieName = config.getAttribute('data-cookie');
  var days = parseInt(config.getAttribute('data-days'), 10);
  if (!handles.length || !cookieName || isNaN(days)) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch;

  function setCookie(on) {
    var base = cookieName + '=' + (on ? '1' : '') + '; path=/; SameSite=Lax';
    document.cookie = base + '; max-age=' + (on ? days * 86400 : 0);
  }

  // One request at a time; a change that arrives mid-request triggers one more read.
  var inFlight = false;
  var again = false;

  function refresh() {
    if (inFlight) { again = true; return; }
    inFlight = true;
    nativeFetch.call(window, root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var hasMomento = items.some(function (item) {
          return handles.indexOf(item.handle) !== -1;
        });
        setCookie(hasMomento);
      })
      .catch(function () {})
      .then(function () {
        inFlight = false;
        if (again) { again = false; refresh(); }
      });
  }

  // Storefront cart writes (theme, UpCart, apps) made with fetch.
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (CART_WRITE.test(url)) {
        p.then(refresh, refresh);
      }
      return p;
    };
  }

  // Cart writes made with XMLHttpRequest.
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_WRITE.test(String(url))) {
      this.addEventListener('loadend', refresh);
    }
    return nativeOpen.apply(this, arguments);
  };

  // UpCart and theme cart events.
  ['cart-updated', 'cart-loaded', 'item-removed'].forEach(function (name) {
    window.addEventListener('aftersell-upcart:public-events:' + name, refresh);
  });
  document.addEventListener('cart:change', refresh);
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  refresh();
})();
